import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Início", href: "#inicio", internal: false },
  { label: "Quem Somos", href: "#quem-somos", internal: false },
  { label: "Soluções", href: "#solucoes", internal: false },
  { label: "Parceiros", href: "#parceiros", internal: false },
  { label: "Clientes", href: "#clientes", internal: false },
  { label: "Contato", href: "#contato", internal: false },
  { label: "Política de Privacidade", href: "/politica-de-privacidade", internal: true },
];

const socials = [
  { icon: "ri-facebook-fill", href: "https://www.facebook.com/solusitbrasil/", label: "Facebook" },
  { icon: "ri-instagram-line", href: "https://www.instagram.com/solus.it/", label: "Instagram" },
  { icon: "ri-linkedin-fill", href: "https://www.linkedin.com/company/solusit/", label: "LinkedIn" },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#000000] text-white">
      {/* Top gradient divider */}
      <div className="solus-divider"></div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-1 mb-4">
            <span className="text-2xl font-black text-white">SOLUS</span>
            <span className="text-2xl font-black solus-gradient-text">IT</span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed max-w-xs mb-5">
            Tecnologia que transforma negócios. Soluções de TI completas para empresas que buscam inovação e resultados.
          </p>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:border-[#62A9E0] hover:text-[#62A9E0] transition-colors cursor-pointer"
              >
                <i className={`${s.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Links */}
        <div>
          <h4 className="text-xs font-bold text-[#62A9E0] uppercase tracking-wider mb-5">Navegação</h4>
          <ul className="space-y-2.5">
            {footerLinks.map((link) => (
              <li key={link.label}>
                {link.internal ? (
                  <Link
                    to={link.href}
                    className="text-sm text-white/60 hover:text-[#62A9E0] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-sm text-white/60 hover:text-[#62A9E0] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-bold text-[#62A9E0] uppercase tracking-wider mb-5">Contato</h4>
          <ul className="space-y-3.5">
            <li className="flex items-center gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0]">
                <i className="ri-phone-line text-base"></i>
              </div>
              (91) 3241-5792
            </li>
            <li className="flex items-center gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0]">
                <i className="ri-phone-line text-base"></i>
              </div>
              (11) 99184-1569
            </li>
            <li className="flex items-center gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0]">
                <i className="ri-mail-line text-base"></i>
              </div>
              comercial@solus-it.com.br
            </li>
            <li className="flex items-center gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0]">
                <i className="ri-mail-line text-base"></i>
              </div>
              licitacao@solus-it.com.br
            </li>
            <li className="flex items-start gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0] mt-0.5">
                <i className="ri-map-pin-line text-base"></i>
              </div>
              Belém, Pará — Brasil
            </li>
            <li className="flex items-start gap-3 text-sm text-white/60">
              <div className="w-5 h-5 flex items-center justify-center text-[#62A9E0] mt-0.5">
                <i className="ri-map-pin-line text-base"></i>
              </div>
              São Paulo, SP — Brasil
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/30">© 2026 Solus IT. Todos os direitos reservados.</p>
          <p className="text-xs text-white/30">CNPJ: 10.348.741/0001-11 — Belém, PA</p>
          <Link to="/politica-de-privacidade" className="text-xs text-white/30 hover:text-[#62A9E0] transition-colors cursor-pointer flex items-center gap-1">
            <i className="ri-shield-check-line text-xs"></i>
            Privacidade &amp; LGPD
          </Link>
        </div>
      </div>
    </footer>
  );
}
